import "./Access.css"
import React, { useContext } from "react";
import { BrandContext } from "../../shared/Shared";

export default function Menu(props) {
    let [Brand, setBrand] = useContext(BrandContext);
    return props.ModuleDetails.map((md, index) => {

        return <button
            className="projButton"
            onClick={() => (window.location.href = md.URL)}
            style={{ backgroundColor: props.BackgroundColor }}
            key={index}
        >
            <span className="containtxttitle">
                <div className="containcircTitle">
                    <div className="circlieLittle" style={{ backgroundColor: Brand, color: md.TitleForeColor }}></div>
                    {md.Title}
                    <span className="dash"> - </span>
                </div>
                <span className="platforntxt">
                    <span className="ssssssss"
                        style={{ backgroundColor: md.BackgroundColor, color: md.SubTitleForeColor }}
                    >
                        {" " + md.Subtitle + " "}{" "}
                    </span>
                    <img
                        src="https://s2.uupload.ir/files/arrow_w6g.png"
                        alt="arrow"
                    />
                </span>
            </span>
        </button>
    })
}